import { defineNuxtPlugin } from 'nuxt/app'
// import vWebp from '~/directives/v-webp'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.config.errorHandler = (err: any, instance, info) => {
    // 处理错误
    // console.error(err, instance, info)
    console.error('7007-7007', err.statusCode)
    // console.log(typeof err)
    // console.log(String(err))
    ElMessage({
      message: `7007-7007-${String(err)}`,
      type: 'error',
      customClass: 'hello_message'
    })
  }
})
